import { render, staticRenderFns } from "./teamIntroduction.vue?vue&type=template&id=d5e89e58&scoped=true"
import script from "./teamIntroduction.vue?vue&type=script&lang=js"
export * from "./teamIntroduction.vue?vue&type=script&lang=js"
import style0 from "./teamIntroduction.vue?vue&type=style&index=0&id=d5e89e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e89e58",
  null
  
)

export default component.exports